import { CommonModule } from '@angular/common';
import { Component, Input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-color-picker',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.css'],
})
export class ColorPickerComponent {
  color = model('#ffffff');
  @Input() disabled = false;

  get colorModel(): string {
    return this.color();
  }

  set colorModel(value: string) {
    const trimmedValue = typeof value === 'string' ? value.trim() : '';

    if (trimmedValue === '') {
      this.color.set('');
      return;
    }

    let hexCandidate = trimmedValue;
    if (hexCandidate.startsWith('#')) {
      hexCandidate = hexCandidate.substring(1);
    }

    hexCandidate = hexCandidate.toUpperCase();

    if (/^([0-9A-F]{3}|[0-9A-F]{6})$/.test(hexCandidate)) {
      this.color.set('#' + hexCandidate);
    }
  }
}
